module.exports = __webpack_public_path__ + "img/bulletin.b7f73728.svg";